import { getProductCollectionByHandle } from "../../app/graphql/types/getProductCollectionByHandle";

export const getProductCollectionByHandleSuccessResponse: getProductCollectionByHandle = {
  productCollection: {
    __typename: "ProductCollection",
    id: "collection-123",
    title: "Vitamins and supplements",
    handle: "vitamins-and-supplements",
    description: null,
    products: {
      __typename: "ProductConnection",
      edges: [
        {
          __typename: "ProductEdge",
          node: {
            __typename: "Product",
            id: "product-1",
            title: "Vitabiotics wellwoman max 84 tablets",
            handle: "vitabiotics-wellwoman-max-84-tablets",
            available: true,
            priceRange: {
              __typename: "PriceRange",
              maxVariantPrice: {
                __typename: "Price",
                value: 2049
              },
              minVariantPrice: {
                __typename: "Price",
                value: 2049
              }
            },
            images: [
              {
                __typename: "ProductImage",
                id: "image-1",
                src:
                  "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/6002092_1024x.jpg",
                altText: ""
              }
            ],
            variants: [
              {
                __typename: "ProductVariant",
                available: true,
                id: "variant_1",
                title: "84 Tablets",
                image: null,
                options: [
                  {
                    __typename: "SelectedOption",
                    name: "Size",
                    value: "84 tablets"
                  }
                ],
                price: {
                  __typename: "Price",
                  value: 2049
                }
              }
            ],
            options: [
              {
                __typename: "ProductOption",
                name: "Size",
                values: ["84 tablets"]
              }
            ]
          }
        },

        {
          __typename: "ProductEdge",
          node: {
            __typename: "Product",
            id: "product-2",
            title: "Vitabiotics wellwoman 50+ pack of 30 tablets",
            handle: "vitabiotics-wellwoman-50-30-tablets",
            available: true,
            priceRange: {
              __typename: "PriceRange",
              maxVariantPrice: {
                __typename: "Price",
                value: 850
              },
              minVariantPrice: {
                __typename: "Price",
                value: 850
              }
            },
            images: [
              {
                __typename: "ProductImage",
                id: "image-2",
                src:
                  "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/7227622_15a03d3a-41ae-41d1-bfd2-6942849e97dc_1024x.jpg",
                altText: ""
              }
            ],
            variants: [
              {
                __typename: "ProductVariant",
                available: true,
                id: "variant_1",
                title: "30 Tablets",
                image: null,
                options: [
                  {
                    __typename: "SelectedOption",
                    name: "Size",
                    value: "30 tablets"
                  }
                ],
                price: {
                  __typename: "Price",
                  value: 850
                }
              }
            ],
            options: [
              {
                __typename: "ProductOption",
                name: "Size",
                values: ["30 tablets"]
              }
            ]
          }
        },

        {
          __typename: "ProductEdge",
          node: {
            __typename: "Product",
            id: "product-3",
            title: "Vitabiotics wellteen her 30 tablets",
            handle: "vitabiotics-wellteen-her-30-tablets",
            available: true,
            priceRange: {
              __typename: "PriceRange",
              maxVariantPrice: {
                __typename: "Price",
                value: 899
              },
              minVariantPrice: {
                __typename: "Price",
                value: 899
              }
            },
            images: [
              {
                __typename: "ProductImage",
                id: "image-3",
                src:
                  "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/6004872_2eec77c7-2ce0-4220-9497-e0d7067338c5_1024x.jpg",
                altText: ""
              }
            ],
            variants: [
              {
                __typename: "ProductVariant",
                available: true,
                id: "variant_1",
                title: "30 Tablets",
                image: null,
                options: [
                  {
                    __typename: "SelectedOption",
                    name: "Size",
                    value: "30 tablets"
                  }
                ],
                price: {
                  __typename: "Price",
                  value: 899
                }
              }
            ],
            options: [
              {
                __typename: "ProductOption",
                name: "Size",
                values: ["30 tablets"]
              }
            ]
          }
        },

        {
          __typename: "ProductEdge",
          node: {
            __typename: "Product",
            id: "product-4",
            title: "Vitabiotics wellwoman original 30 capsules",
            handle: "vitabiotics-wellwoman-original-30-capsules",
            available: true,
            priceRange: {
              __typename: "PriceRange",
              maxVariantPrice: {
                __typename: "Price",
                value: 649
              },
              minVariantPrice: {
                __typename: "Price",
                value: 649
              }
            },
            images: [
              {
                __typename: "ProductImage",
                id: "image-4",
                src:
                  "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/2660165_1024x.jpg",
                altText: ""
              }
            ],
            variants: [
              {
                __typename: "ProductVariant",
                available: true,
                id: "variant_1",
                title: "30 Tablets",
                image: null,
                options: [
                  {
                    __typename: "SelectedOption",
                    name: "Size",
                    value: "30 tablets"
                  }
                ],
                price: {
                  __typename: "Price",
                  value: 649
                }
              }
            ],
            options: [
              {
                __typename: "ProductOption",
                name: "Size",
                values: ["30 tablets"]
              }
            ]
          }
        },

        {
          __typename: "ProductEdge",
          node: {
            __typename: "Product",
            id: "product-5",
            title: "Vitabiotics wellman 70+ 30 tablets",
            handle: "vitabiotics-wellman-70-30-tablets",
            available: true,
            priceRange: {
              __typename: "PriceRange",
              maxVariantPrice: {
                __typename: "Price",
                value: 999
              },
              minVariantPrice: {
                __typename: "Price",
                value: 999
              }
            },
            images: [
              {
                __typename: "ProductImage",
                id: "image-5",
                src:
                  "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/3727450_631f8d90-47a1-442d-a54c-8ab0ffaa765a_1024x.jpg",
                altText: ""
              }
            ],
            variants: [
              {
                __typename: "ProductVariant",
                available: true,
                id: "variant_1",
                title: "30 Tablets",
                image: null,
                options: [
                  {
                    __typename: "SelectedOption",
                    name: "Size",
                    value: "30 tablets"
                  }
                ],
                price: {
                  __typename: "Price",
                  value: 999
                }
              }
            ],
            options: [
              {
                __typename: "ProductOption",
                name: "Size",
                values: ["30 tablets"]
              }
            ]
          }
        },

        {
          __typename: "ProductEdge",
          node: {
            __typename: "Product",
            id: "product-6",
            title: "Berocca blackcurrant 15 tablets",
            handle: "berocca-blackcurrant-15-tablets",
            available: true,
            priceRange: {
              __typename: "PriceRange",
              maxVariantPrice: {
                __typename: "Price",
                value: 729
              },
              minVariantPrice: {
                __typename: "Price",
                value: 729
              }
            },
            images: [
              {
                __typename: "ProductImage",
                id: "image-6",
                src:
                  "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/6017139_1024x.jpg",
                altText: ""
              }
            ],
            variants: [
              {
                __typename: "ProductVariant",
                available: true,
                id: "variant_1",
                title: "15 Tablets",
                image: null,
                options: [
                  {
                    __typename: "SelectedOption",
                    name: "Size",
                    value: "15 tablets"
                  }
                ],
                price: {
                  __typename: "Price",
                  value: 729
                }
              }
            ],
            options: [
              {
                __typename: "ProductOption",
                name: "Size",
                values: ["15 tablets"]
              }
            ]
          }
        },

        {
          __typename: "ProductEdge",
          node: {
            __typename: "Product",
            id: "product-7",
            title: "Vitabiotics wellman 50+ 30 tablets",
            handle: "vitabiotics-wellman-50-30-tablets",
            available: true,
            priceRange: {
              __typename: "PriceRange",
              maxVariantPrice: {
                __typename: "Price",
                value: 1049
              },
              minVariantPrice: {
                __typename: "Price",
                value: 1049
              }
            },
            images: [
              {
                __typename: "ProductImage",
                id: "image-7",
                src:
                  "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/3289899_1024x.jpg",
                altText: ""
              }
            ],
            variants: [
              {
                __typename: "ProductVariant",
                available: true,
                id: "variant_1",
                title: "30 Tablets",
                image: null,
                options: [
                  {
                    __typename: "SelectedOption",
                    name: "Size",
                    value: "30 tablets"
                  }
                ],
                price: {
                  __typename: "Price",
                  value: 1049
                }
              }
            ],
            options: [
              {
                __typename: "ProductOption",
                name: "Size",
                values: ["30 tablets"]
              }
            ]
          }
        },

        {
          __typename: "ProductEdge",
          node: {
            __typename: "Product",
            id: "product-8",
            title: "Natures Aid multi-vitamin orange mini drops 50ml",
            handle: "natures-aid-multi-vitamin-orange-mini-drops-50ml",
            available: true,
            priceRange: {
              __typename: "PriceRange",
              maxVariantPrice: {
                __typename: "Price",
                value: 795
              },
              minVariantPrice: {
                __typename: "Price",
                value: 795
              }
            },
            images: [
              {
                __typename: "ProductImage",
                id: "image-8",
                src:
                  "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/6212914_01_1024x.jpg",
                altText: ""
              }
            ],
            variants: [
              {
                __typename: "ProductVariant",
                available: true,
                id: "variant_1",
                title: "50ml",
                image: null,
                options: [
                  {
                    __typename: "SelectedOption",
                    name: "Size",
                    value: "50ml"
                  }
                ],
                price: {
                  __typename: "Price",
                  value: 795
                }
              }
            ],
            options: [
              {
                __typename: "ProductOption",
                name: "Size",
                values: ["50ml"]
              }
            ]
          }
        },

        {
          __typename: "ProductEdge",
          node: {
            __typename: "Product",
            id: "product-9",
            title: "Vitabiotics wellkid multi-vitamin liquid 150ml",
            handle: "vitabiotics-wellbaby-multi-vitamin-liquid-150ml",
            available: true,
            priceRange: {
              __typename: "PriceRange",
              maxVariantPrice: {
                __typename: "Price",
                value: 699
              },
              minVariantPrice: {
                __typename: "Price",
                value: 699
              }
            },
            images: [
              {
                __typename: "ProductImage",
                id: "image-9",
                src:
                  "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/6025049_1024x.jpg",
                altText: ""
              }
            ],
            variants: [
              {
                __typename: "ProductVariant",
                available: true,
                id: "variant_1",
                title: "150ml",
                image: null,
                options: [
                  {
                    __typename: "SelectedOption",
                    name: "Size",
                    value: "150ml"
                  }
                ],
                price: {
                  __typename: "Price",
                  value: 699
                }
              }
            ],
            options: [
              {
                __typename: "ProductOption",
                name: "Size",
                values: ["150ml"]
              }
            ]
          }
        },

        {
          __typename: "ProductEdge",
          node: {
            __typename: "Product",
            id: "product-10",
            title: "Vitawell A-Z multivitamin mega pack",
            handle: "vitawell-a-z-multivitamin-mega-pack",
            available: true,
            priceRange: {
              __typename: "PriceRange",
              maxVariantPrice: {
                __typename: "Price",
                value: 500
              },
              minVariantPrice: {
                __typename: "Price",
                value: 500
              }
            },
            images: [
              {
                __typename: "ProductImage",
                id: "image-9",
                src:
                  "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/6025542_1024x.jpg",
                altText: ""
              }
            ],
            variants: [
              {
                __typename: "ProductVariant",
                available: true,
                id: "variant_1",
                title: "150 tablets",
                image: null,
                options: [
                  {
                    __typename: "SelectedOption",
                    name: "Size",
                    value: "150 tablets"
                  }
                ],
                price: {
                  __typename: "Price",
                  value: 500
                }
              }
            ],
            options: [
              {
                __typename: "ProductOption",
                name: "Size",
                values: ["150 tablets"]
              }
            ]
          }
        },

        {
          __typename: "ProductEdge",
          node: {
            __typename: "Product",
            id: "product-11",
            title: "Vitabiotics wellwoman plus 56 tablets",
            handle: "vitabiotics-wellwoman-plus-56-tablets",
            available: true,
            priceRange: {
              __typename: "PriceRange",
              maxVariantPrice: {
                __typename: "Price",
                value: 1099
              },
              minVariantPrice: {
                __typename: "Price",
                value: 1099
              }
            },
            images: [
              {
                __typename: "ProductImage",
                id: "image-10",
                src:
                  "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/3580107_fda3f5d8-5702-43c1-b0d9-f9fc8bfd2c3a_1024x.jpg",
                altText: ""
              }
            ],
            variants: [
              {
                __typename: "ProductVariant",
                available: true,
                id: "variant_1",
                title: "56 tablets",
                image: null,
                options: [
                  {
                    __typename: "SelectedOption",
                    name: "Size",
                    value: "56 tablets"
                  }
                ],
                price: {
                  __typename: "Price",
                  value: 1099
                }
              }
            ],
            options: [
              {
                __typename: "ProductOption",
                name: "Size",
                values: ["56 tablets"]
              }
            ]
          }
        },

        {
          __typename: "ProductEdge",
          node: {
            __typename: "Product",
            id: "product-12",
            title: "Vitabiotics wellteen him 30 tablets",
            handle: "vitabiotics-wellteen-him-30-tablets",
            available: true,
            priceRange: {
              __typename: "PriceRange",
              maxVariantPrice: {
                __typename: "Price",
                value: 1399
              },
              minVariantPrice: {
                __typename: "Price",
                value: 1399
              }
            },
            images: [
              {
                __typename: "ProductImage",
                id: "image-12",
                src:
                  "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/6004874_1024x.jpg",
                altText: ""
              }
            ],
            variants: [
              {
                __typename: "ProductVariant",
                available: true,
                id: "variant_1",
                title: "30 tablets",
                image: null,
                options: [
                  {
                    __typename: "SelectedOption",
                    name: "Size",
                    value: "30 tablets"
                  }
                ],
                price: {
                  __typename: "Price",
                  value: 1399
                }
              }
            ],
            options: [
              {
                __typename: "ProductOption",
                name: "Size",
                values: ["30 tablets"]
              }
            ]
          }
        }
      ],
      cursor: "12",
      totalCount: 13
    }
  }
};

export const getProductCollectionByHandleLoadMoreSuccessResponse: getProductCollectionByHandle = {
  productCollection: {
    __typename: "ProductCollection",
    id: "collection-123",
    title: "Vitamins and supplements",
    handle: "vitamins-and-supplements",
    description: null,
    products: {
      __typename: "ProductConnection",
      edges: [
        {
          __typename: "ProductEdge",
          node: {
            __typename: "Product",
            id: "product-13",
            title: "Solgar® Pycnogenol 100 mg vegetable capsules",
            handle: "solgar®-pycnogenol-100-mg-vegetable-capsules",
            available: true,
            priceRange: {
              __typename: "PriceRange",
              maxVariantPrice: {
                __typename: "Price",
                value: 7249
              },
              minVariantPrice: {
                __typename: "Price",
                value: 7249
              }
            },
            images: [
              {
                __typename: "ProductImage",
                id: "image-13",
                src:
                  "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/7317514_1024x.jpg",
                altText: ""
              }
            ],
            variants: [
              {
                __typename: "ProductVariant",
                available: true,
                id: "variant_1",
                title: "30 capsules",
                image: null,
                options: [
                  {
                    __typename: "SelectedOption",
                    name: "Size",
                    value: "30 capsules"
                  }
                ],
                price: {
                  __typename: "Price",
                  value: 7249
                }
              }
            ],
            options: [
              {
                __typename: "ProductOption",
                name: "Size",
                values: ["30 capsules"]
              }
            ]
          }
        }
      ],
      cursor: "",
      totalCount: 13
    }
  }
};
